// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3n6Fo","containerItemsCenter":"Skeleton_containerItemsCenter__9lpmS"};